import {
  Modal as MUIModal,
  Fade,
  Box,
  Backdrop,
  ThemeProvider,
} from "@mui/material";
import { ReactNode } from "react";
import "./Modal.scss";
import { Row } from "../Row";
import { useBqaTheme } from "../../hooks/theme";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title: ReactNode; // Probably a string
}

/**
 * Popup window. This will always display in light mode
 */
export function Modal(props: ModalProps) {
  const theme = useBqaTheme(true);
  const close = () => props.onClose();
  return (
    <ThemeProvider theme={theme}>
      <MUIModal
        open={props.open}
        onClose={close}
        slots={{
          backdrop: () => (
            <Backdrop
              className="modal-backdrop"
              style={{
                opacity: 0.2,
                width: "100%",
                height: "100%",
                transition: "5s fade in out",
              }}
              open={props.open}
              onClick={close}
              transitionDuration={5000}
            />
          ),
        }}
        className="modal-component"
      >
        <Fade in={props.open} timeout={400}>
          <Box
            className="light-mode modal-box"
            style={{
              transform: "translate(-50%, -50%)",
              top: "40%",
              left: "50%",
              position: "absolute",
              width: 400,
              borderRadius: "2rem",
              padding: "1rem 1.5rem",
            }}
          >
            <Row style={{ marginBottom: "1rem" }}>
              <h2 style={{ margin: 0 }}>{props.title}</h2>
              <button
                onClick={close}
                style={{
                  position: "absolute",
                  right: 10,
                  top: 10,
                  fontSize: 32,
                }}
                aria-label="Close"
              >
                &times;
              </button>
            </Row>
            {props.children}
          </Box>
        </Fade>
      </MUIModal>
    </ThemeProvider>
  );
}
